import { Registerable } from '@baserow/modules/core/registry'

import PermisosDeColumnaItem from '@extras_mg/components/PermisosDeColumnaItem'

/**
 * "Permisos de la columna" en el menú de cada columna.
 *
 * Mismo nombre de tipo que el de enterprise ('field-permissions') para ocupar
 * su sitio en el registro: el suyo salía a todos con candado y el modal de
 * precios. Ver PermisosDeColumnaItem.
 */
export class PermisosDeColumnaContextItemType extends Registerable {
  static getType() {
    return 'field-permissions'
  }

  getComponent() {
    return PermisosDeColumnaItem
  }
}
